import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetLocationPermissionRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetLocationPermissionResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setLocationPermission = (request: SetLocationPermissionRequest, options?: CashRequestOptions) =>
  post<SetLocationPermissionRequest, SetLocationPermissionResponse>('/2.0/cash/set-location-permission', request, {
    ...options,
    rejectOnError: true,
  })
